const React = require('react');
const CancelablePromise = require('mn-utils/CancelablePromise');
const delay = require('mn-utils/delay');
const trim = require('mn-utils/trim');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const {
  CURRENCY_ITEMS,
} = require('../../../../../constants');
const withState = require('../../../../../utils/withState');
const {
  apiV2KycBankSubmit,
} = require('../../../../../api/merchant/kyc');
const TextField = require('../../../../dumb/TextField/I');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const Select = require('../../../../dumb/Select/F');
const ButtonSave = require('./Button/Save');
const ButtonNext = require('./Button/Next');
const {COUNTRIES} = require("../../../../../constants/countries");
const Field = require("../../../../dumb/Field/E");


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);
  const handleChangeBankName = changeProvider('bankName');
  const handleChangeBankAddress = changeProvider('bankAddress');
  const handleChangeIbanAccountNumber = changeProvider('ibanAccountNumber');
  const handleChangeSwiftCode = changeProvider('swiftCode');
  const handleChangePayoutCurrency = handleProvider('payoutCurrency');
  const handleChangeCountry = handleProvider('country');

  let _defaultState;


  function update() {
    delay(() => {
      const next = _defaultState || {};
      setState({
        bankName: next.name,
        bankAddress: next.address,
        ibanAccountNumber: next.iban,
        swiftCode: next.swift_code,
        payoutCurrency: next.fiat_code,
        country: next.country,
      });
    });
  }

  onMount(() => {
    self.props.onMount();
  });

  return (state, props) => {
    const defaultState = props.defaultState;
    const {
      clicked,
    } = state;

    const bankName = state.bankName || '';
    const bankAddress = state.bankAddress || '';
    const ibanAccountNumber = state.ibanAccountNumber || '';
    const swiftCode = state.swiftCode || '';
    const payoutCurrency = state.payoutCurrency;
    const country = state.country || '';

    const invalidBankName = !trim(bankName);
    const invalidBankAddress = !trim(bankAddress);
    const invalidIbanAccountNumber = !trim(ibanAccountNumber);
    const invalidSwiftCode = !trim(swiftCode);
    const invalidPayoutCurrency = !payoutCurrency;
    const invalidCountry = !country;
    const disabled = invalidPayoutCurrency
      || invalidIbanAccountNumber
      || invalidBankName
      || invalidSwiftCode
      || invalidBankAddress
      || invalidCountry;


    _defaultState === defaultState || update(_defaultState = defaultState);


    function submit() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return CancelablePromise.reject();
      }
      setState({
        loading: true,
      });
      return apiV2KycBankSubmit({
        swift_code: trim(swiftCode),
        address: trim(bankAddress),
        name: trim(bankName),
        iban: trim(ibanAccountNumber),
        country: country,
        fiat_code: payoutCurrency,
      }).finally(() => {
        setState({
          loading: false,
        });
      });
    }


    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1">
          <div>
            <Select
              placeholder="Please select your primary payout currency *"
              propName={({
                id,
                name,
                main,
              }) => !main && name ? `${id} - ${name}` : id}
              propValue="id"
              displayEmpty
              items={CURRENCY_ITEMS}
              value={payoutCurrency}
              error={clicked && invalidPayoutCurrency}
              onChange={handleChangePayoutCurrency}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="IBAN / Account number *"
              value={ibanAccountNumber}
              error={clicked && invalidIbanAccountNumber}
              onChange={handleChangeIbanAccountNumber}
            />
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt20">
          <div>
            <TextField
              label="SWIFT code *"
              value={swiftCode}
              error={clicked && invalidSwiftCode}
              onChange={handleChangeSwiftCode}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="Bank name *"
              value={bankName}
              error={clicked && invalidBankName}
              onChange={handleChangeBankName}
            />
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt20">
          <div>
            <TextField
              label="Bank address *"
              value={bankAddress}
              error={clicked && invalidBankAddress}
              onChange={handleChangeBankAddress}
            />
          </div>
          <div className="mt20@m">
            <Select
              placeholder="Country *"
              error={clicked && invalidCountry}
              propName="0"
              propValue="1"
              displayEmpty
              items={COUNTRIES}
              value={country}
              onChange={handleChangeCountry}
              helperText="Obligatory field"
            />
          </div>
        </div>
        <div className="cfx (lt|ph10|w1/2|w@m)>1 mt20 ph10">
          <div className="f12 fw3 lh18 lts0em tl o50">
            *If you want to add multiple bank accounts
            for different currencies, you can do so later
            in the console.
          </div>
        </div>
        <div className="layoutRow fvaC fhaB mt54">
          <ButtonSave
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.onSubmit);
            }}
          />
          <ButtonNext
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.handleSubmitAndNext);
            }}
          >
            Finish
          </ButtonNext>
        </div>
      </WrapperWithLoading>
    );
  };
}, {});
